import React, { useEffect, useRef } from "react";
import SectionDocuments from "../../../../Sections/ElementsSections/SectionDocuments/SectionDocuments";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function DocumentsForTabs({ props }) {
  const mainBlock = useRef(null);

  useEffect(() => {
    const docDiv = mainBlock.current.querySelector(`#Documents${props.SectionID}`);
    if (docDiv && docDiv.refreshMainGrid) {
      docDiv.refreshMainGrid({
        DocCfgID: props.DocCfgID || props.ObjType,
        ParentID: props.ParentID ?? props.selectedRecordID,
      });
    }
  }, [props]);

  return (
    <div ref={mainBlock} style={{ height: "100%" }}>
      <SectionDocuments
        sectionRights={props.rights}
        id={props.SectionID}
        DocCfgID={props.DocCfgID || props.ObjType}
        ParentID={props.ParentID ?? props.selectedRecordID}
        HideParams={true}
        SectionToolsJS={false}
        PlaneView={"0"}
        setRecorcCount={() => {}}
        HideControlButtons={true}
        footerID={`footerData_${props.SectionID}`}
        noAutoFocus={true}
      />
    </div>
  );
}
